import Vue from 'vue'
import './../assets/theme/index.css'
import { Button,Loading,Carousel,CarouselItem ,Input,Backtop,Icon,Row,Col,Message,MessageBox,infiniteScroll,Image} from 'element-ui'

Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(infiniteScroll)
Vue.use(Image)
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$prompt = MessageBox.prompt;

